import React from 'react';

// v3.13 CODEX CARD — restructured to mirror the GameCard layout (name at top → art center → desc → footer).
// This removes the "weird box above name" chip and keeps every Codex/Discovery/Divine entry visually consistent.
export default function CodexCard({
  art, name, type, cost, costLabel, costColor,
  desc, footer, locked, testid, borderColor, accent,
}) {
  const displayName = locked ? '???' : name;
  const displayArt  = locked ? '?' : art;
  const displayType = locked ? '???' : type;
  const displayDesc = locked ? 'Undiscovered. Encounter this to unlock.' : desc;
  const bColor = borderColor || (locked ? '#333' : accent) || 'var(--muted)';
  const shadow = locked ? 'none' : `4px 4px 0 ${bColor}`;

  return (
    <div
      className={`codex-card ${locked ? 'is-locked' : ''}`}
      style={{ borderColor: bColor, boxShadow: shadow }}
      data-testid={testid}
      data-locked={locked ? 'true' : 'false'}
    >
      {cost != null && !locked && (
        <div
          className="codex-card-cost"
          style={{ background: costColor || '#39ff14', color: '#000' }}
          data-testid={testid ? `${testid}-cost` : undefined}
        >{cost}</div>
      )}
      {costLabel && !locked && (
        <div className="codex-card-costlabel" style={{ color: bColor }}>{costLabel}</div>
      )}
      <div className="codex-card-name" style={{ color: bColor }}>{displayName}</div>
      {type && (
        <div className="codex-card-type-inline" style={{ color: bColor, opacity: 0.8 }}>
          {displayType}
        </div>
      )}
      <div className="codex-card-art" data-testid={testid ? `${testid}-art` : undefined}>
        <span aria-hidden="true">{displayArt}</span>
      </div>
      <div className="codex-card-desc">{displayDesc}</div>
      {footer && <div className="codex-card-footer">{footer}</div>}
    </div>
  );
}
